"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/legacy_portal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalShippingService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.shipping.v1.LegacyPortalShippingService
 */
exports.LegacyPortalShippingService = {
    typeName: "spwn.shipping.v1.LegacyPortalShippingService",
    methods: {
        /**
         * fulfillment_firestore_idを指定して配送状況を取得
         *
         * @generated from rpc spwn.shipping.v1.LegacyPortalShippingService.GetShippingStatusByFulfillmentFirestoreId
         */
        getShippingStatusByFulfillmentFirestoreId: {
            name: "GetShippingStatusByFulfillmentFirestoreId",
            I: legacy_portal_service_pb_1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest,
            O: legacy_portal_service_pb_1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * SPWNの住所を取得
         *
         * @generated from rpc spwn.shipping.v1.LegacyPortalShippingService.GetLegacyPortalAddressInfo
         */
        getLegacyPortalAddressInfo: {
            name: "GetLegacyPortalAddressInfo",
            I: legacy_portal_service_pb_1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest,
            O: legacy_portal_service_pb_1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map